module.exports = __webpack_public_path__ + "static/flags/GM-88aca95ac7a20b049e99627e13305147.gif";